export const DeviceFloorplanType = {
  DISPLAY: {
    key: 'DISPLAY',
    label: '일반 디스플레이',
    defaultIcon: 'material-symbols:desktop-windows-outline-rounded',
  },
  KIOSK: {
    key: 'KIOSK',
    label: '키오스크',
    defaultIcon: 'material-symbols:touch-app',
  },
  MENU_BOARD: {
    key: 'MENU_BOARD',
    label: '메뉴보드',
    defaultIcon: 'material-symbols:tv-outline-rounded',
  },
  LED_WALL: {
    key: 'LED_WALL',
    label: 'LED 월',
    defaultIcon: 'material-symbols:digital-out-of-home-rounded',
  },
  WAYFINDING: {
    key: 'WAYFINDING',
    label: '길찾기',
    defaultIcon: 'material-symbols:map-outline-rounded',
  },
} as const;

export const DeviceFloorplanIcon = {
  DESKTOP: {
    key: 'DESKTOP',
    label: '데스크톱',
    icon: 'material-symbols:desktop-windows-outline-rounded',
  },
  TOUCH: {
    key: 'TOUCH',
    label: '터치스크린',
    icon: 'material-symbols:touch-app',
  },
  TV: {
    key: 'TV',
    label: 'TV',
    icon: 'material-symbols:tv-outline-rounded',
  },
  SIGNAGE: {
    key: 'SIGNAGE',
    label: '사이니지',
    icon: 'material-symbols:digital-out-of-home-rounded',
  },
  MAP: {
    key: 'MAP',
    label: '길찾기',
    icon: 'material-symbols:map-outline-rounded',
  },
  STORE: {
    key: 'STORE',
    label: '매장',
    icon: 'material-symbols:storefront-outline-rounded',
  },
} as const;

export const DeviceFloorplanHistoryAction = {
  ADDED: {
    key: 'ADDED',
    label: '추가',
  },
  MOVED: {
    key: 'MOVED',
    label: '이동',
  },
  REMOVED: {
    key: 'REMOVED',
    label: '삭제',
  },
} as const;

export type DeviceFloorplanType = keyof typeof DeviceFloorplanType;
export type DeviceFloorplanIcon = keyof typeof DeviceFloorplanIcon;
export type DeviceFloorplanHistoryAction =
  keyof typeof DeviceFloorplanHistoryAction;
